import { makeAutoObservable, runInAction } from "mobx";
import api from "../Utils/api";

class MyProfileStore {
  profile = null;

  loaded = false;

  inviteCode = null;
  inviteCodeRequest = false;

  modalState = {
    invite: false
  };

  constructor() {
    makeAutoObservable(this);
  }

  load() {
    api.getMyProfile().then((res) => {
      runInAction(() => {
        this.profile = res;
        this.loaded = true;
      });
    });
  }

  getInviteCode(){
    this.inviteCodeRequest = true;
    api.getInviteCode().then(res=>{
      runInAction(()=>{
        this.inviteCodeRequest = false;
        this.inviteCode = res.code;
      })
    })
  }

  loadExistingInvite() {
    this.inviteCodeRequest = true;
    return api.getMyInvites().then(res => {
      runInAction(() => {
        this.inviteCodeRequest = false;
        if (res.invites && res.invites.length > 0) {
          this.inviteCode = res.invites[0].code;
        } else {
          this.inviteCode = null;
        }
      });
    });
  }

  openInviteModal() {
    this.modalState.invite = true;
    this.loadExistingInvite();
  }

  closeInviteModal() {
    this.modalState.invite = false;
  }

  uploadProfilePic(avatar) {
    return api.uploadProfilePic(avatar);
  }
}

const myProfileStore = new MyProfileStore();
export default myProfileStore;
